module.exports = __webpack_public_path__ + "img/bj.afdc74cd.png";